export const REDUX_SET = '/redux/container/RentalModalContainer/set';
export const REDUX_RESET = '/redux/container/RentalModalContainer/reset';
